import styled from "styled-components";
import { designSystemVars as vars } from "../tokens";
import { Button } from "./Button";
import { Modal } from "./Dialog";

export interface ConfirmationModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationMessage = styled.p`
  margin: 0;
  color: ${vars.color.text.primary};
  font-family: ${vars.typography.family.sans};
  font-size: ${vars.typography.size.md};
  line-height: ${vars.typography.lineHeight.md};
`;

const ConfirmationContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${vars.spacing.lg};
`;

const ConfirmationActions = styled.div`
  display: flex;
  gap: ${vars.spacing.lg};
`;

const ConfirmationButton = styled(Button).attrs({ size: "lg" })`
  width: 100%;
  height: 48px;
  border-radius: ${vars.radius.lg};
  font-size: ${vars.typography.size.lg};
`;

export const ConfirmationModal = ({
  visible,
  setVisible,
  message,
  confirmText = "Yes",
  cancelText = "No",
  onConfirm,
  onCancel,
}: ConfirmationModalProps) => (
  <Modal
    open={visible}
    title="Confirmation"
    onClose={() => setVisible(false)}
    size="sm"
    intent="confirmation"
    showHeader={false}
    showCloseButton={false}
    closeOnEscape={false}
    closeOnOverlayClick
  >
    <ConfirmationContent>
      <ConfirmationMessage>{message}</ConfirmationMessage>
      <ConfirmationActions>
        <ConfirmationButton onClick={onConfirm}>
          {confirmText}
        </ConfirmationButton>
        <ConfirmationButton onClick={onCancel}>{cancelText}</ConfirmationButton>
      </ConfirmationActions>
    </ConfirmationContent>
  </Modal>
);
